<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-num">PART I</p>
<div class="image-break">
<p class="image"><img alt="Images" src="images/img.jpg"/></p>
</div>
<p class="chap-title">MOVING INTO THE TRENCHES</p>
<p class="subhead1"><i>The Yanks Go to War</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?d60b0b68